module.exports = __webpack_public_path__ + "static/img/monitoramento-pesquisa.8bff936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/monitoramento-pesquisa.png
// module id = lzzP
// module chunks = 1